export const EDIT_CLIENT_DETAILS_MODAL = 'EDIT_CLIENT_DETAILS_MODAL';
